import Header from './headers/Header';
import Footer from './footer/Footer';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import SideMenu from './side-menu/SideMenu';
import { useLazyGetContactQuery } from '../modules/contact-us/redux/ContactUsApi';
import { useEffect } from 'react';
import { useAppDispatch } from '../redux/Hooks';
import { setContacts } from '../modules/login/redux/LoginSlice';

const { Content } = Layout;

const LayoutApp = () => {
    const [contactTrigger] = useLazyGetContactQuery();
    const dispatch = useAppDispatch();

    useEffect(() => {
        contactTrigger({ type: 0 }).unwrap().then(res => {
            dispatch(setContacts(res))
        })
    }, [contactTrigger, dispatch])

    return (
        <Layout>
            <SideMenu />
            <Header />
            <Content style={{ overflowX: 'hidden' }}><Outlet /></Content>
            <Footer />
        </Layout>
    )
}

export default LayoutApp;